<template>
  <div class="bg-white dark:bg-dark-900 relative overflow-hidden min-h-[50px]">
    <div class="bg-gradient-to-r absolute w-[200%] top-0 left-0 h-full skeleton opacity-5" :class="[ getColors() ]" v-if="isAnimated" />

    <slot />
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  size?: string
  isAnimated?: boolean
  color?: string
}>(), {
  size: '',
  isAnimated: false,
  color: 'gray'
})

const getColors = () => {
  if (props.color == 'gray') return 'from-charcoal-950/0 via-charcoal-900/10 to-charcoal-900/0 dark:from-dark-400/0 dark:via-dark-400/10 dark:to-dark-400/0'
  if (props.color == 'cobra') return 'from-cobra-500/0 via-cobra-500/10 to-cobra-500/0'
  if (props.color == 'tiger') return 'from-tiger-300/0 via-tiger-300/10 to-tiger-300/0'

  return 'from-whale-500/0 via-whale-500/10 to-whale-500/0'
}

</script>